"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLBAR_LINK_TITLE_ID = exports.TOOLBAR_LINK_MODAL_WIDTH = exports.TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = exports.TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = exports.FOOTER_TEXT_FONT_SIZE = exports.FOOTER_TEXT_FONT_COLOR = void 0;
var TOOLBAR_LINK_TITLE_ID = 'toolbar-link-title';
exports.TOOLBAR_LINK_TITLE_ID = TOOLBAR_LINK_TITLE_ID;
var TOOLBAR_LINK_MODAL_WIDTH = 512;
exports.TOOLBAR_LINK_MODAL_WIDTH = TOOLBAR_LINK_MODAL_WIDTH;
var TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = 16;
exports.TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP;
var TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = 8;
exports.TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE;
var FOOTER_TEXT_FONT_SIZE = 'T100';
exports.FOOTER_TEXT_FONT_SIZE = FOOTER_TEXT_FONT_SIZE;
var FOOTER_TEXT_FONT_COLOR = 'neutral70';
exports.FOOTER_TEXT_FONT_COLOR = FOOTER_TEXT_FONT_COLOR;